import { storybookReady } from '../../../core/js/utils'

let storybook

(async function() {
  storybook = await storybookReady()

  let tingleLogin = document.querySelector('.Tingle-Login')
  if (tingleLogin) {
    let login = document.querySelector('.Header__User')
    login && login.addEventListener('click', (event) => {
      event.preventDefault()
      const modal = new tingle.modal({
        closeLabel: '',
        cssClass: ['Login-Popup']
      })
      modal.setContent(tingleLogin.innerHTML)
      modal.open()
    })
  }

  let search = document.querySelector('.Header__Search')
  let searchMenu = document.querySelector('.menu-search')
  let fairs = document.querySelector('.Header__Fairs')
  let fairsMenu = document.querySelector('#menu-fairs')

  document.querySelectorAll('#button-humburger-menu, .fake-button-menu').forEach(item => {
    item.addEventListener('click', (event) => {
      event.preventDefault()
      toggleMenu('menu')
    })
  })

  search && search.addEventListener('click', (event) => {
    event.preventDefault()
    toggleMenu('menu', false)
    toggleMenu('menu-fairs', false)
    searchMenu && searchMenu.classList.toggle('opened')
  })

  fairs && fairs.addEventListener('click', (event) => {
    event.preventDefault()
    toggleMenu('menu-fairs')
  })

  fairsMenu && fairsMenu.querySelectorAll('.fair').forEach(item => {
    item.querySelector('.layer-fair').style.width = '278px'
    item.querySelectorAll('.open-layer, .close-menu').forEach(item2 => {
      item2.addEventListener('click', (event) => {
        event.preventDefault()
        item.classList.toggle('opened')
      })
    })
  })

})()

function toggleMenu(menu, open) {
  if (typeof open === 'undefined') {
    open = !document.body.classList.contains('menu-opened')
  }

  let pageContent = document.querySelector('#page-content')
  if (open) {
    pageContent.dataset.menu = menu
    pageContent.style.height = window.innerHeight + 'px'
  } else {
    delete pageContent.dataset.menu
    pageContent.style.height = ''
  }

  setTimeout(() => {
    if (open) {
      document.body.classList.add('menu-opened')
      document.querySelector('#page-container').classList.add('menu-opened')
      pageContent.classList.add('menu-opened')
    } else {
      document.body.classList.remove('menu-opened')
      document.querySelector('#page-container').classList.remove('menu-opened')
      pageContent.classList.remove('menu-opened')
    }
  }, 0)
}
